import axios from "axios";
import { useEffect, useReducer, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { profileReducer } from "../../functions/reducers";
import Header from "../../components/header";
import "./style.css";
import Cover from "./Cover";
import ProfielPictureInfos from "./ProfielPictureInfos";
import ProfileMenu from "./ProfileMenu";
// import PplYouMayKnow from "./PplYouMayKnow";
import CreatePost from "../../components/createPost";
import GridPosts from "./GridPosts";
import Post from "../../components/post";
import Photos from "./Photos";
import Videos from "./Videos";
import Tagged from "./Tagged";
import Highlights from "./Highlights.js";
import Archive from "./Archive.js";
import Friends from "./Friends";
import About from "./About";
import More from "./More";
import Intro from "../../components/intro";
import { useMediaQuery } from "react-responsive";
import CreatePostPopup from "../../components/createPostPopup";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { HashLoader } from "react-spinners";

export default function Profile({ getAllPosts }) {
  const [visible, setVisible] = useState(false);
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'
  const [isUpdateProfilePictureOpen, setIsUpdateProfilePictureOpen] = useState(false);
  const [isEditDetailsOpen, setIsEditDetailsOpen] = useState(false);
  const { username } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state) => ({ ...state }));
  const [photos, setPhotos] = useState({});
  const [videos, setVideos] = useState({});
  var userName = username === undefined ? user.username : username;

  // Determine current tab based on URL
  const currentPath = location.pathname;
  const currentTab = currentPath.includes('/about') ? 'about' :
                    currentPath.includes('/friends') ? 'friends' :
                    currentPath.includes('/photos') ? 'photos' :
                    currentPath.includes('/videos') ? 'videos' :
                    currentPath.includes('/tagged') ? 'tagged' :
                    currentPath.includes('/highlights') ? 'highlights' :
                    currentPath.includes('/archive') ? 'archive' :
                    currentPath.includes('/more') ? 'more' : 'posts';

  const [{ loading, profile }, dispatch] = useReducer(profileReducer, {
    loading: false,
    profile: {},
    error: "",
  });
  
  useEffect(() => {
    getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);
  
  useEffect(() => {
    setOthername(profile?.details?.otherName);
  }, [profile]);

  // Re-render when URL changes (tab switching)
  useEffect(() => {
    // Force re-render when tab changes
  }, [currentPath, currentTab]);

  var visitor = userName === user.username ? false : true;
  const [othername, setOthername] = useState();

  const getProfile = async () => {
    try {
      dispatch({
        type: "PROFILE_REQUEST",
      });
      const { data } = await axios.get(`/getProfile/${userName}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      if (data.ok === false) {
        navigate("/profile");
      } else {
        // Extract photos from posts
        const extractPhotosFromPosts = (posts) => {
          const photos = [];
          posts.forEach(post => {
            if (post.images && post.images.length > 0) {
              post.images.forEach(image => {
                if (image.type === "image") {
                  photos.push({
                    url: image.url,
                    postId: post._id,
                    createdAt: post.createdAt
                  });
                }
              });
            }
          });
          return photos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        };

        // Extract videos from posts
        const extractVideosFromPosts = (posts) => {
          const videos = [];
          posts.forEach(post => {
            if (post.images && post.images.length > 0) {
              post.images.forEach(image => {
                if (image.type === "video") {
                  videos.push({
                    url: image.url,
                    postId: post._id,
                    createdAt: post.createdAt
                  });
                }
              });
            }
          });
          return videos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        };
        
        const photosFromPosts = extractPhotosFromPosts(data.posts || []);
        const videosFromPosts = extractVideosFromPosts(data.posts || []);
        
        setPhotos({
          resources: photosFromPosts,
          total_count: photosFromPosts.length
        });

        setVideos({
          resources: videosFromPosts,
          total_count: videosFromPosts.length
        });
        
        dispatch({
          type: "PROFILE_SUCCESS",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "PROFILE_ERROR",
        payload: error.response.data.message,
      });
    }
  };

  const profileTop = useRef(null);
  const leftSide = useRef(null);
  const [height, setHeight] = useState();
  const [leftHeight, setLeftHeight] = useState();
  const [scrollHeight, setScrollHeight] = useState();
  
  useEffect(() => {
    setHeight(profileTop.current.clientHeight + 300);
    if (leftSide.current) {
      setLeftHeight(leftSide.current.clientHeight);
    } else {
      setLeftHeight(0);
    }
    window.addEventListener("scroll", getScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", getScroll);
    };
  }, [loading, scrollHeight]);
  
  const check = useMediaQuery({
    query: "(min-width:901px)",
  });
  
  const getScroll = () => {
    setScrollHeight(window.pageYOffset);
  };

  // Check if profile has bio or hobbies
  const hasBioOrHobbies = () => {
    if (!profile?.details) return false;
    const details = profile.details;
    return !!(details.bio || (details.hobbies && details.hobbies.length > 0));
  };

  // Render left sidebar content based on current tab
  const renderLeftSidebar = () => {
    if (loading) {
      return (
        <div className="profile_card">
          <div className="profile_card_header">Loading...</div>
          <div className="sekelton_loader">
            <HashLoader color="#1876f2" />
          </div>
        </div>
      );
    }

     // For visitor profiles, show Intro for all tabs if they have bio or hobbies
     if (visitor && hasBioOrHobbies()) {
       return (
         <Intro
           detailss={profile?.details || {}}
           visitor={visitor}
           setOthername={setOthername}
           onEditDetailsOpen={setIsEditDetailsOpen}
         />
       );
     }

     switch (currentTab) {
       case 'about':
         return (
           <Intro
             detailss={profile?.details || {}}
             visitor={visitor}
             setOthername={setOthername}
             onEditDetailsOpen={setIsEditDetailsOpen}
           />
         );
       case 'posts':
         return (
           <Intro
             detailss={profile?.details || {}}
             visitor={visitor}
             setOthername={setOthername}
             onEditDetailsOpen={setIsEditDetailsOpen}
           />
         );
       case 'friends':
       case 'photos':
       case 'videos':
       case 'tagged':
       case 'more':
       default:
         return null; // No left sidebar content for these tabs
     }
  };

  // Check if we should show left sidebar
  const shouldShowLeftSidebar = () => {
    // Show for about/posts tabs, or if visitor profile has bio/hobbies (but not for Tagged, Videos, Photos, Friends)
    if (loading) return true;
    if (currentTab === 'about' || currentTab === 'posts') return true;
    // Don't show profile_card for Tagged, Videos, Photos, Friends tabs
    const tabsWithoutProfileCard = ['tagged', 'videos', 'photos', 'friends'];
    if (tabsWithoutProfileCard.includes(currentTab)) return false;
    if (visitor && hasBioOrHobbies()) return true;
    return false;
  };

  // Render main content based on current tab
  const renderMainContent = () => {
    if (loading) {
      return (
        <div className="sekelton_loader">
          <HashLoader color="#1876f2" />
        </div>
      );
    }

    switch (currentTab) {
      case 'about':
        return <About profile={profile || {}} visitor={visitor} />;
      case 'friends':
        return (
          <div className="friends_full_view">
            <Friends friends={profile?.friends || []} />
          </div>
        );
      case 'photos':
        return (
          <div className="photos_full_view">
            <Photos 
              username={userName} 
              token={user.token} 
              photos={photos.resources ? photos : { resources: [], total_count: 0 }} 
            />
          </div>
        );
      case 'videos':
        return (
          <div className="videos_full_view">
            <Videos 
              username={userName} 
              token={user.token} 
              videos={videos.resources ? videos : { resources: [], total_count: 0 }} 
            />
          </div>
        );
      case 'tagged':
        return (
          <div className="tagged_full_view">
            <Tagged 
              username={userName} 
              token={user.token} 
            />
          </div>
        );
      case 'highlights':
        return (
          <div className="highlights_full_view">
            <Highlights 
              username={userName} 
              token={user.token}
              visitor={visitor}
              profileId={profile?._id}
            />
          </div>
        );
      case 'archive':
        return !visitor ? (
          <div className="highlights_full_view">
            <Archive token={user.token} />
          </div>
        ) : (
          <div className="private_account_message">Only the profile owner can view the Archive.</div>
        );
      case 'more':
        return <More profile={profile || {}} />;
      case 'posts':
      default:
        // Show privacy message if private and not follower/self
        if (
          profile.privacy === "private" &&
          !profile.friendship?.following &&
          user.id !== profile._id
        ) {
          return (
            <div className="private_account_message">
              This account is private. Only followers can see posts and stories.
            </div>
          );
        }
        return (
          <>
            {!visitor && (
              <CreatePost 
                user={user} 
                profile 
                setVisible={setVisible} 
                getAllPosts={getAllPosts}
                dispatch={dispatch}
              />
            )}
            <GridPosts viewMode={viewMode} setViewMode={setViewMode} />
            {profile.posts && profile.posts.length ? (
              (() => {
                const visiblePosts = profile.posts.filter(p => !p.archived && !p.deleted);
                if (visiblePosts.length === 0) {
                  return <div className="no_posts">No posts available</div>;
                }
                const pinned = visiblePosts.find(p => p.pinned);
                const others = visiblePosts.filter(p => !p.pinned);
                return (
                  <div className={`posts ${viewMode === 'grid' ? 'posts_grid' : ''}`}>
                    {pinned && (
                      <Post
                        post={pinned}
                        user={user}
                        key={pinned._id}
                        profile
                        gridView={viewMode === 'grid'}
                        onPostDeleted={getProfile}
                      />
                    )}
                    {others.map(post => (
                      <Post
                        post={post}
                        user={user}
                        key={post._id}
                        profile
                        gridView={viewMode === 'grid'}
                        onPostDeleted={getProfile}
                      />
                    ))}
                  </div>
                );
              })()
            ) : (
              <div className="no_posts">No posts available</div>
            )}
          </>
        );
    }
  };

  return (
    <div className={`profile${isUpdateProfilePictureOpen ? ' profile_edit_modal_open' : ''}${isEditDetailsOpen ? ' profile_edit_details_open' : ''}`}>
      {visible && (
        <CreatePostPopup
          user={user}
          setVisible={setVisible}
          posts={profile?.posts}
          dispatch={dispatch}
          profile
        />
      )}
              <Header 
          page="profile" 
          getAllPosts={getAllPosts}
          showMessengerSidebar={false}
          onMessengerToggle={() => {}}
        />
      <div className="profile_top" ref={profileTop}>
        <div className="profile_container">
          {loading ? (
            <>
              <div className="profile_cover">
                <Skeleton
                  height="347px"
                  containerClassName="avatar-skeleton"
                  style={{ borderRadius: "8px" }}
                />
              </div>
              <div
                className="profile_img_wrap"
                style={{
                  marginBottom: "-3rem",
                  transform: "translateY(-8px)",
                }}
              >
                <div className="profile_w_left">
                  <Skeleton
                    circle
                    height="180px"
                    width="180px"
                    containerClassName="avatar-skeleton"
                    style={{ transform: "translateY(-3.3rem)" }}
                  />
                  <div className="profile_w_col">
                    <div className="profile_identity">
                      <div className="profile_name">
                        <Skeleton
                          height="35px"
                          width="100%"
                          containerClassName="avatar-skeleton"
                        />
                      </div>
                      <div className="profile_friend_count">
                        <Skeleton
                          height="20px"
                          width="90px"
                          containerClassName="avatar-skeleton"
                        />
                      </div>
                    </div>
                    <div className="profile_friend_imgs">
                      {Array.from(new Array(6), (val, i) => i + 1).map(
                        (id, i) => (
                          <Skeleton
                            key={id}
                            circle
                            height="32px"
                            width="32px"
                            containerClassName="avatar-skeleton"
                            style={{ transform: `translateX(${-i * 7}px)` }}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className={`friendship ${!visitor && "fix"}`}>
                  <Skeleton
                    height="36px"
                    width={120}
                    containerClassName="avatar-skeleton"
                  />
                  <div className="flex">
                    <Skeleton
                      height="36px"
                      width={120}
                      containerClassName="avatar-skeleton"
                    />
                    {visitor && (
                      <Skeleton
                        height="36px"
                        width={120}
                        containerClassName="avatar-skeleton"
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Cover
                cover={profile.cover}
                visitor={visitor}
                photos={photos.resources}
              />
              <ProfielPictureInfos
                profile={profile}
                visitor={visitor}
                photos={photos.resources}
                othername={othername}
                loading={loading}
                onUpdateProfilePictureOpen={setIsUpdateProfilePictureOpen}
              />
            </>
          )}

          {!isUpdateProfilePictureOpen && <ProfileMenu />}
        </div>
      </div>
       <div className="profile_bottom">
         <div className={`profile_container ${currentTab === 'posts' ? 'posts_page_container' : ''}`}>
           <div className="bottom_container">
             <div
               className={`profile_grid ${
                 check && scrollHeight >= height && leftHeight > 1000
                   ? "scrollFixed showLess"
                   : check &&
                     scrollHeight >= height &&
                     leftHeight < 1000 &&
                     "scrollFixed showMore"
               } ${!shouldShowLeftSidebar() ? 'profile_grid_single_column' : ''} ${
                 currentTab === 'posts' ? 'posts_page_layout' : ''
               }`}
             >
              {/* Left sidebar - show conditionally */}
              {shouldShowLeftSidebar() && (
                <div className="profile_left" ref={leftSide}>
                  {renderLeftSidebar()}
                  <div className="relative_fb_copyright">
                    <Link to="/Privacy">Privacy </Link>
                    <span>. </span>
                    <Link to="/terms">Terms </Link>
                    <span>. </span>
                    {/* <Link to="/">Advertising </Link>
                    <span>. </span>
                    <Link to="/">
                      Ad Choices <i className="ad_choices_icon"></i>{" "}
                    </Link> */}
                    {/* <span>. </span> */}
                    {/* <Link to="/cookies">Cookies </Link> */}
                    {/* <Link to="/">More </Link> */}
                     <br />
                    <Link to="/">UsmaApp © 2024</Link>
                  </div>
                </div>
              )}
              
              <div className={`profile_right ${!shouldShowLeftSidebar() ? 'profile_right_full' : ''}`}>
                {renderMainContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
